export default "__VITE_ASSET__CzxPmj04__"